import { StatisticMinMaxDataItem } from "../../models/types/statistic";
import { useLookupParameter } from "../../utils/get-lookup";
import dayjs from "dayjs";

const StatisticMinMaxTable = ({ staticData, loading }: { staticData: StatisticMinMaxDataItem[]; loading?: boolean }) => {
    const { lookupParameter } = useLookupParameter();
    const columns = [
        'Thông số',
        'Thời gian tối đa',
        'Giá trị tối đa',
        'Thời gian tối thiểu',
        'Giá trị tối thiểu',
        'Trung bình',
        'Số lần vượt ngưỡng',
    ];

    return (
        <table className="h-full overflow-y-auto w-full relative overflow-x-auto statistic-table">
            <thead className="">
                <tr>
                    {columns.map((column, idx) => {
                        return (
                            <th key={idx} className="min-w-[100px] p-2">{column}</th>
                        )
                    })}
                </tr>
            </thead>
            <tbody>
                {loading ? (
                    <tr>
                        <td colSpan={columns.length} className="text-center py-4">
                            <div className="flex items-center justify-center">
                                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-gray-900"></div>
                            </div>
                        </td>
                    </tr>
                ) : staticData?.length === 0 ? (
                    <tr>
                        <td colSpan={columns.length} className="text-center py-4">
                            <div className="flex items-center justify-center">
                                <div className="text-gray-500">Chưa có dữ liệu</div>
                            </div>
                        </td>
                    </tr>
                ) : staticData?.map((item: any, idx: number) => {
                    const unit = lookupParameter.find((p: any) => p.id === item.parameterId)?.unitName;
                    return (
                        <tr key={idx}>
                            <td className="px-1 py-0">{item.parameterName + (unit ? ` (${unit})` : ' (-)')}</td>
                            <td className="px-1 py-0">{item.maxTime ? dayjs(item.maxTime).format('DD/MM/YYYY HH:mm') : "-"}</td>
                            <td className="px-1 py-0">{item.maxValue ? item.maxValue : "-"}</td>
                            <td className="px-1 py-0">{item.minTime ? dayjs(item.minTime).format('DD/MM/YYYY HH:mm') : "-"}</td>
                            <td className="px-1 py-0">{item.minValue ? item.minValue : "-"}</td>
                            <td className="px-1 py-0">{item.avgValue ? item.avgValue : "-"}</td>
                            <td className="px-1 py-0">{item.countExceeding ? item.countExceeding : "-"}</td>
                        </tr>
                    )
                })}
            </tbody>
        </table>
    )
}

export default StatisticMinMaxTable;
